module.exports = __webpack_public_path__ + "img/testi-left-arrow.31b1c306.svg";